import { Component, OnDestroy, computed } from '@angular/core';
import { ICreateManageUserState, IManageuser } from 'src/app/store/createManageUser/state';
import { getManagingUserInfo } from '../store/createManageUser/selector';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'bmt-manage-user-auth',
    templateUrl: './manage-user-or-auth.component.html',
    styleUrls: ['./manage-user-or-auth.component.scss'],
    standalone: false
})
export class ManageUserOrAuthComponent implements OnDestroy {
  luxId = 'BMT-manage-user-auth' + this.constructor.name;
  private readonly userInfoSignal = toSignal(this.lux.get(getManagingUserInfo, this.luxId), { initialValue: null as IManageuser | null });
  private readonly pageToShowSignal = computed(() => this.userInfoSignal()?.selectedAction || '');

  get userInfo(): IManageuser | null {
    return this.userInfoSignal();
  }

  get pageToShow(): string {
    return this.pageToShowSignal();
  }

  get pageTitle(): string {
    return this.pageToShow === 'authorizations' ? 'User Authorizations' : 'Manage User';
  }

  constructor(private readonly lux: Lux<{ createManageUserState: ICreateManageUserState }>) {
  }

  ngOnDestroy(): void {
    this.lux.destroy(this.luxId);
  }


}
